import Analytics from '@withlocals/withlocals-analytics';
import { fetchAccountInformation } from 'modules/authentication/helpers/auth';
import req from 'utils/req';
import useAuthStore from '~/authentication/store';

import { ActionType, ProfileInfo } from './model';

export type AccountInfoFormActions = {
  setAccount(account: any): void;
  setIsPristine(value: boolean): void;
  setAccountInformation(
    formData: ProfileInfo,
    accountId: string,
    formName: string,
  ): Promise<void>;
  updatePhoto(photo: string): void;
  updateField(name: string, value: any): void;
};

function actionsFactory(
  dispatch: (action: ActionType) => void,
): AccountInfoFormActions {
  return {
    setAccount(account) {
      const data = {
        firstName: account.firstName,
        lastName: account.lastName_full,
        day_of_birth: account?.day_of_birth,
        gender: account?.gender,
        photo: account?.photo,
        personalTitle: account?.personal_title,
        long_bio: account?.long_bio,
        email: account.email,
        phone: account.phone,
        fullName: `${account.firstName} ${account.lastName_full}`,
        languages:
          account?.languages.map(({ language_code }) => language_code) ?? [],
        country: account.address?.country,
        address: account.address,
      };
      dispatch({ type: 'SET_ACCOUNT', payload: { data } });
    },
    setIsPristine(value) {
      dispatch({ type: 'SET_IS_PRISTINE', payload: { value } });
    },
    setAccountInformation(formData, accountId, formName) {
      return new Promise(async (_, reject) => {
        dispatch({ type: 'SET_ACCOUNT_INFO' });

        const body = {
          id: accountId,
          details: {
            firstName: formData.firstName,
            lastName: formData.lastName,
            fullName: formData.fullName,
            email: formData.email,
            long_bio: formData.long_bio,
            personalTitle: formData.personalTitle,
            day_of_birth: formData.day_of_birth,
            gender: formData.gender,
            languages: formData.languages,
          },
          phone: formData.phone,
        };

        try {
          await req(`${URL_API_HOST}/api/v2/profile/${accountId}/full`).put(
            body,
          );
          await fetchAccountInformation(useAuthStore.getState(), {
            silent: true,
          });
          Analytics.track(
            `${formName} form`,
            'Save form',
            accountId.split('-').join(''),
          );
          dispatch({
            type: 'SET_ACCOUNT_INFO_SUCCESS',
            payload: { data: formData },
          });
        } catch (e) {
          dispatch({ type: 'SET_ACCOUNT_INFO_FAILED' });
          return reject();
        }
      });
    },
    async updatePhoto(newPhoto) {
      dispatch({ type: 'UPDATE_PHOTO' });
      try {
        const { url } = await req(
          `${URL_API_HOST}/api/v1/photo/url/profile?url=${newPhoto}`,
        ).get();
        await fetchAccountInformation(useAuthStore.getState(), {
          silent: true,
        });
        dispatch({ type: 'UPDATE_PHOTO_SUCCESS', payload: { photo: url } });
      } catch (err) {
        // nothing?
      }
    },
    updateField(name: string, value: any): void {
      dispatch({ type: 'UPDATE_FIELD_VALUE', payload: { name, value } });
    },
  };
}

export default actionsFactory;
